import {Component, Input} from '@angular/core';
import {WelcomeTile} from '../types';
import {NgIf} from '@angular/common';
import {AssetVersionPipe} from '../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-signals-welcome-pop',
  imports: [NgIf, AssetVersionPipe],
  templateUrl: './signals-welcome-pop.component.html',
  styleUrl: './signals-welcome-pop.component.scss'
})
export class SignalsWelcomePopComponent {

  @Input() title: string = 'Welcome to POLARIS™ Signals!';
  @Input() subTitle: string = 'Polaris compares your campaigns to the market and surfaces the exact actions you should take to stay ahead.';
  @Input() welcomeTiles: WelcomeTile[] = [
    {
      title: 'Data-Backed Evidence',
      icon: 'svg/chart-bar.svg',
      description: 'Quantified metrics supporting each recommendation'
    },
    {
      title: 'Clear Actions',
      icon: 'svg/chart-polar.svg',
      description: 'Specific, implementable next steps'
    },
    {
      title: 'AI Explanations',
      icon: 'svg/chat-box.svg',
      description: 'Ask Polaris to explain any signal in detail'
    },
  ];
  public showPop: boolean = true;

  close(): void {
    this.showPop = false;
  }

}
